export const GET_MANAGER_BOOKS_REQUEST = 'GET_MANAGER_BOOKS_REQUEST' as const;
export const GET_MANAGER_BOOKS_SUCCESS = 'GET_MANAGER_BOOKS_SUCCESS' as const;
export const GET_MANAGER_BOOKS_ERROR = 'GET_MANAGER_BOOKS_ERROR' as const;

export const PUT_BOOK_REQUEST = 'PUT_BOOKS_REQUEST' as const;
export const PUT_BOOK_SUCCESS = 'PUT_BOOKS_SUCCESS' as const;
export const PUT_BOOK_ERROR = 'PUT_BOOKS_ERROR' as const;

export const PUT_BLOCK_ALL_REQUEST = 'PUT_BLOCK_ALL_REQUEST' as const;
export const PUT_BLOCK_ALL_SUCCESS = 'PUT_BLOCK_ALL_SUCCESS' as const;
export const PUT_BLOCK_ALL_ERROR = 'PUT_BLOCK_ALL_ERROR' as const;

export const PUT_EDIT_BOOK_REQUEST = 'PUT_EDIT_BOOKS_REQUEST' as const;
export const PUT_EDIT_BOOK_SUCCESS = 'PUT_EDIT_BOOKS_SUCCESS' as const;
export const PUT_EDIT_BOOK_ERROR = 'PUT_EDIT_BOOKS_ERROR' as const;

export const POST_BOOK_REQUEST = 'POST_BOOK_REQUEST' as const;
export const POST_BOOK_SUCCESS = 'POST_BOOK_SUCCESS' as const;
export const POST_BOOK_ERROR = 'POST_BOOK_ERROR' as const;

export const POST_CELL_REQUEST = 'POST_CELL_REQUEST' as const;
export const POST_CELL_SUCCESS = 'POST_CELL_SUCCESS' as const;
export const POST_CELL_ERROR = 'POST_CELL_ERROR' as const;

export const PUT_BLOCK_REQUEST = 'PUT_BLOCK_REQUEST' as const;
export const PUT_BLOCK_SUCCESS = 'PUT_BLOCK_SUCCESS' as const;
export const PUT_BLOCK_ERROR = 'PUT_BLOCK_ERROR' as const;

export const CLEAR_ERROR_BOOKINGS = 'CLEAR_ERROR_BOOKINGS' as const;

export const GET_CELL_SETTINGS_REQUEST = 'GET_CELL_SETTINGS_REQUEST' as const;
export const GET_CELL_SETTINGS_SUCCESS = 'GET_CELL_SETTINGS_SUCCESS' as const;
export const GET_CELL_SETTINGS_ERROR = 'GET_CELL_SETTINGS_ERROR' as const;

export const GET_LOCKED_CELL_REQUEST = 'GET_LOCKED_CELL_REQUEST' as const;
export const GET_LOCKED_CELL_SUCCESS = 'GET_LOCKED_CELL_SUCCESS' as const;
export const GET_LOCKED_CELL_ERROR = 'GET_LOCKED_CELL_ERROR' as const;
